import React from 'react';
import {RouteComponentProps} from '@reach/router';

const App = React.lazy(() => import('./app'));

type HostedCheckoutProps = RouteComponentProps & {};
export const HostedCheckout: React.FC<HostedCheckoutProps> = () => <App />;
